import { z } from 'zod';

import { RTESchema } from './RTE';
import { ImageSchema } from './Image';
import { CollectionFileSchema, FileSchema } from '../types/File.schema';
import { ImageCrop } from '../types/Image';

const StubSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(3).default(''),
    description: RTESchema.optional().nullable(),
    button: z
        .object({
            label: z.string().optional().nullable(),
            url: z.string().url().optional().nullable(),
        })
        .optional()
        .nullable(),
    image: z
        .union([z.string(), ImageSchema.nullable().default(null)])
        .optional()
        .nullable(),
    imageCrop: z.nativeEnum(ImageCrop).optional(),
    files: CollectionFileSchema.array().optional(),
    tags: z.string().array().optional().nullable(),
});

const StubSchemaPayload = StubSchema.extend({
    files: z
        .object({
            file: FileSchema.shape.id,
        })
        .array()
        .default([]),
});

export { StubSchema, StubSchemaPayload };
